
export default function routes($stateProvider) {
	$stateProvider
		.state('surveysPage', {
			url: '/surveys',
			template: require('./surveys.html'),
			resolve: {
				loggedIn: ['User', function (User) {
					return User.requireLogin();
				}],
				surveys: ['Survey', function (Survey) {
					return Survey.all();
				}]
			},
			controller: 'SurveysController',
			controllerAs: 'surveys'
		});
}

routes.$inject = ['$stateProvider'];



// WEBPACK FOOTER //
// ./src/page/surveys/surveys.routes.js